/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Map_Vehicles_OnlineInputs */

const fr_map_vehicles_online = /** @type {(inputs: Map_Vehicles_OnlineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Véhicules en ligne (${i?.count})`)
};

const en_map_vehicles_online = /** @type {(inputs: Map_Vehicles_OnlineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Online vehicles (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Online vehicles ({count})" |
*
* @param {Map_Vehicles_OnlineInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const map_vehicles_online = /** @type {((inputs: Map_Vehicles_OnlineInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Vehicles_OnlineInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_map_vehicles_online(inputs)
	return en_map_vehicles_online(inputs)
});